import { Reveal } from "./Reveal";

export default function Founder() {
  return (
    <section id="about" data-testid="founder-bio-section" className="bg-[#0B0B12] px-4 sm:px-8 lg:px-12 py-14 sm:py-20 lg:py-28">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-8 lg:gap-12 items-center">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="overflow-hidden rounded-3xl border border-[#A89DE3]/20 shadow-2xl shadow-black/40">
              <img
                src="/images/crystal.jpg"
                alt="Crystal Stretch — founder of HERcules Health"
                data-testid="founder-image"
                loading="lazy"
                decoding="async"
                className="w-full h-[340px] sm:h-[560px] object-cover object-top hover:scale-105 transition-transform duration-700"
              />
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal>
            <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.25em] text-[#A89DE3]">Your Coach</p>
            <h2 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl text-[#FFFFFF] mt-4">
              WHO AM I?
            </h2>
            <p data-testid="founder-name-text" className="font-display font-bold text-[#7C89FF] text-xl sm:text-2xl mt-4 tracking-tight">
              I'M CRYSTAL STRETCH
            </p>
          </Reveal>
          <Reveal delay={0.15} className="mt-5 sm:mt-6 text-[#D9D6EC] text-sm sm:text-base md:text-lg leading-relaxed space-y-4 sm:space-y-5">
            <p>
              Functional Health Specialist, physique coach, competitive bodybuilder and founder of HERcules Health.
              I specialize in helping women who are already DOING THE WORK but can't understand why their bodies aren't responding.
            </p>
            <p>
              My coaching goes beyond macros + workouts. I look at nutrition, digestion, sleep, stress, recovery, hormones,
              metabolic function and Data. When a woman tells me,{" "}
              <span className="text-[#FFFFFF] italic">&ldquo;I'm doing everything right. Why the fuck isn't this working?&rdquo;</span>{" "}
              my answer isn't automatically &ldquo;eat less.&rdquo; I want to understand WHY.
            </p>
            <p className="font-display font-bold text-[#FFFFFF]">A HEALTHY BODY IS A RESPONSIVE BODY.</p>
            <p>
              For 14 days, experience the foundational reset I use with my private clients -{" "}
              <span className="text-[#7C89FF] font-semibold">FREE</span>.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
